import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Toolbar.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface ToolbarMenuProps {
  title: string | React.ReactNode
  children: React.ReactNode
  action?: React.ReactNode
  inDesigner?: boolean
  height?: number
}

export const ToolbarMenu = ({ title, children, action, inDesigner, height }: ToolbarMenuProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <div className={cx(Styles.toolbarMenu, { [Styles.inDesigner]: inDesigner })}>
      <div className={Styles.toolbarMenuHeader} style={{ height }}>
        {isSystemRedesignEnabled ? (
          <Text variant="secondary">{title}</Text>
        ) : (
          <>{inDesigner ? <Heading level={5}>{title}</Heading> : <Text variant="smallList">{title}</Text>}</>
        )}
        {action}
      </div>
      {children}
    </div>
  )
}
